import { useMutation, useQueryClient } from '@tanstack/react-query';

import { KimLhcService } from '@/infra/services/kim-lhc';
import { QUERY_KEYS } from '@/utils/query-keys';

interface CalculateScoresParams {
	id: string;
	file_id: string;
	company_id: string;
	organization_id: string;
	frequency?: number;
	weight?: number;
	inclined_weight?: boolean;
	transporting_cargo_in_pairs?: boolean;
	cargo_handling_condition?: string;
	body_posture?: string;
	posture_additional_factor_twist?: string | null;
	posture_additional_factor_load_center?: string | null;
	posture_additional_factor_arms?: string | null;
	posture_additional_factor_hands?: string | null;
	work_condition_hands_position?: string | null;
	work_condition_transfer?: string | null;
	work_condition_spatial_condition?: string | null;
	work_condition_adverse?: string | null;
	work_condition_clothes?: string | null;
	work_condition_hold_load?: string | null;
	work_organization?: string;
}

const Service = KimLhcService.getInstance();

export const useCalculateKimLhcScores = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: CalculateScoresParams) => await Service.calculateScores(params),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_KIM_LHC] });
		}
	});
};
